<template>
	<div ref="adBlock" class="adBanner"></div>
</template>

<script>
export default {
	name: 'detectAdBlock',
	description: 'Component used to detect ad block running on the current page',
	mounted() {
		this.detectAdBlock();
	},
	methods: {
		detectAdBlock() {
			if (this.$refs && this.$refs.adBlock && this.$refs.adBlock.clientHeight <= 0) {
				this.$emit('detected');
			}
		}
	},
};
</script>

<style lang="less" scoped>
	.adBanner {
		background-color: transparent;
		height: 1px;
		width: 1px;
	}
</style>
